document.querySelectorAll('.model-toggle-button').forEach(button => {
    button.addEventListener('click', function () {
        if (this.classList.contains('is-active')) return;

        // Toggle active class
        document.querySelectorAll('.model-toggle-button').forEach(btn => btn.classList.remove('is-active'));
        this.classList.add('is-active');

        // Change view mode
        const grid = document.getElementById('product-grid') || document.getElementById('wishlist-grid');
        if (!grid) return;

        const newMode = this === document.querySelectorAll('.model-toggle-button')[0] ? 'grid' : 'list';
        grid.setAttribute('data-view-mode', newMode);

        updateViewMode(grid, newMode);
    });
});

function adjustImageContainers() {
    const items = Array.from(document.querySelectorAll('.product_item')).filter(item => !item.closest('.strawberry-collection'));
    let minX = Infinity;

    items.forEach(item => {
        const img = item.querySelector('.product-img');
        if (!img) return;

        const h = parseFloat(img.getAttribute('height'));
        const w = parseFloat(img.getAttribute('width'));
        const containerWidth = item.getBoundingClientRect().width;

        if (w && h && containerWidth) {
            const calculatedHeight = containerWidth * (h / w);
            if (calculatedHeight < minX) {
                minX = calculatedHeight;
            }
        }
    });

    // Set the height of each .product_image block to the smallest x found
    document.querySelectorAll('.product_image').forEach(block => {
        if (!block.closest('.strawberry-collection')) {
            block.style.height = minX + 'px';
        }
    });
}

function adjustStrawberryImageContainers() {
    const items = Array.from(document.querySelectorAll('.strawberry-collection .product_item'));
    if (items.length === 0) return;

    let minHeight = Infinity;

    items.forEach(item => {
        const img = item.querySelector('.product-img');
        if (!img) return;

        const h = parseFloat(img.getAttribute('height'));
        const w = parseFloat(img.getAttribute('width'));
        const containerWidth = item.getBoundingClientRect().width;

        if (w && h && containerWidth) {
            const calculatedHeight = containerWidth * (h / w);
            if (calculatedHeight < minHeight) {
                minHeight = calculatedHeight;
            }
        }
    });

    items.forEach(item => {
        const block = item.querySelector('.product_image');
        if (block) {
            block.style.height = minHeight + 'px';
        }
    });
}

function updateSizes(productItem, selectedColor) {
    const sizesContainer = productItem.querySelector(".product_sizes");
    const productData = productItem.dataset.product.split(",");
    if (!sizesContainer) {
        return
    }

    sizesContainer.innerHTML = "";

    const availableSizes = productData
        .map(entry => entry.split("|"))
        .filter(entry => entry[0] === selectedColor)
        .map(entry => ({
            label: entry[1],
            available: entry[2] === "true",
            variantId: entry[3]
        }));

    availableSizes.forEach(size => {
        const button = document.createElement("button");
        button.textContent = size.label;
        button.className = "size-option";
        button.disabled = !size.available;

        button.addEventListener("click", () => {
            const form = productItem.querySelector("product-form form");
            const variantInput = form.querySelector('input[name="id"]');
            variantInput.value = size.variantId;

            // Trigger the submit event (quick-add)
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });

        sizesContainer.appendChild(button);
    });
}


function updateMedia(productItem, selectedColor) {
    const raw = productItem.dataset.variantMediaMap;
    if (raw !== undefined) {
        const mediaMap = JSON.parse(raw);

        const imageContainer = productItem.querySelector(".image-container");
        imageContainer.innerHTML = "";

        if (Object.keys(mediaMap)[0].toLowerCase() === "all") {
            selectedColor = "all"
        }

        const entries = (mediaMap[selectedColor] || '').split(';').filter(Boolean);

        console.log(entries)

        entries.forEach((entry, index) => {
            const img = document.createElement("img");
            img.classList.add("product-img");
            if (index === 0) img.classList.add("visible");

            img.setAttribute("src", entry);
            img.setAttribute("loading", "lazy");
            imageContainer.appendChild(img);
        });
    }
}

function bindProductCardEvents(container = document) {
    console.log("🔁 Binding in:", container);

    container.querySelectorAll(".color-swatch").forEach(swatch => {
        swatch.addEventListener("click", async function (event) {
            event.preventDefault();
            const productItem = swatch.closest(".product_item");
            const selectedColor = swatch.dataset.color;
            const productHandle = productItem.dataset.handle;

            productItem.querySelectorAll(".color-swatch").forEach(s => s.classList.remove("is-active"));
            swatch.classList.add("is-active");

            updateSizes(productItem, selectedColor);
            await updateImages(productItem, selectedColor, productHandle);
        });
    });

    container.querySelectorAll(".product_item").forEach(productItem => {
        productItem.addEventListener("click", function (event) {
            const ignoredSelectors = [
                '.carousel-controls',
                '.product_sizes',
                '.color_swatches',
                '.product_variants',
                '.product_variants_wrapper',
                'modal-opener',
                'modal-dialog',
                '.button-popup-option'
            ];

            const shouldIgnore = ignoredSelectors.some(selector =>
                event.target.closest(selector)
            );

            if (!shouldIgnore) {
                const url = productItem.dataset.url;
                if (url) {
                    window.location.href = url;
                }
            }
        });

        // Optionally update sizes on first load of the card
        const color = productItem.dataset.defaultColor;
        updateSizes(productItem, color);
    });
}

function updateViewMode(grid, mode) {
    const productItems = grid.querySelectorAll('.product_item');

    productItems.forEach(item => {
        const productImage = item.querySelector('.product_image');
        if (!productImage) return;

        const images = productImage.querySelectorAll('.product-img');
        if (images.length === 0) return;

        const controls = item.querySelector('.carousel-controls');

        images.forEach(img => img.classList.remove('visible'));

        if (mode === 'list') {
            images[images.length - 1].classList.add('visible');
            if (controls) controls.style.display = 'none';
        } else {
            images[0].classList.add('visible');
            if (controls) controls.style.display = 'flex';
        }
    });
}

function getViewMode() {
    const grid = document.getElementById('product-grid');
    return grid?.getAttribute('data-view-mode') || 'grid';
}

async function updateImages(productItem, selectedColor, productHandle) {
    try {
        const res = await fetch(`/products/${productHandle}.js`);
        const product = await res.json();

        const allMedia = product.media || [];
        const imageContainer = productItem.querySelector(".image-container");
        imageContainer.innerHTML = "";

        // Try to filter by alt
        let filteredImages = allMedia.filter(media =>
            media.media_type === "image" &&
            media.alt &&
            media.alt.toLowerCase() === selectedColor.toLowerCase()
        );

        // If nothing found, fallback to all images
        if (filteredImages.length === 0) {
            filteredImages = allMedia.filter(media => media.media_type === "image");
        }

        filteredImages.forEach((media, index) => {
            const img = document.createElement("img");
            img.src = media.preview_image.src;
            img.alt = media.alt || '';
            img.loading = "lazy";
            img.classList.add("product-img");

            const isList = getViewMode() === 'list';
            if ((isList && index === filteredImages.length - 1) || (!isList && index === 0)) {
                img.classList.add("visible");
            }

            imageContainer.appendChild(img);
        });

    } catch (err) {
        console.error("Failed to fetch media:", err);
    }
}

function changeImage(button, direction) {
    let productItem = button.closest('.product_image');
    let images = productItem.querySelectorAll('.product-img');
    let index = [...images].findIndex(img => img.classList.contains('visible'));

    if (index === -1) return false;

    images[index].classList.remove('visible');

    let newIndex = direction === 'prev'
        ? (index - 1 >= 0 ? index - 1 : images.length - 1)
        : (index + 1 < images.length ? index + 1 : 0);

    images[newIndex].classList.add('visible');
}
function waitForProductsInside(el, callback) {
    const maxAttempts = 30;
    let attempts = 0;

    const interval = setInterval(() => {
        if (el.querySelector('.product_item')) {
            clearInterval(interval);
            callback(el);
        }

        attempts++;
        if (attempts > maxAttempts) clearInterval(interval);
    }, 200);
}

function observeRecommendations() {
    const targets = document.querySelectorAll('product-recommendations');

    targets.forEach(target => {
        const observer = new MutationObserver(() => {
            if (target.dataset.bound === "true") return; // ✅ prevent rebinding

            const productsReady = target.querySelector('.product_item');
            if (productsReady) {
                bindProductCardEvents(target);
                adjustImageContainers(target);

                target.dataset.bound = "true";
                observer.disconnect();
            }
        });

        observer.observe(target, { childList: true, subtree: true });
    });
}

// Run on load + observe after
document.addEventListener("DOMContentLoaded", () => {
    console.log("✅ DOM ready — binding for full page");
    bindProductCardEvents();
    adjustImageContainers();
    adjustStrawberryImageContainers();
    observeRecommendations();
});

window.addEventListener('resize', () => {
    adjustImageContainers();
    adjustStrawberryImageContainers();
});



async function onSwatchClick(e) {
        const swatch = e.target.closest(".product_item .color-swatch");
        if (!swatch) return;

        e.preventDefault();
        e.stopPropagation();

        const productItem = swatch.closest(".product_item");

        productItem.querySelectorAll(".color-swatch").forEach((s) => s.classList.remove("is-active"));
        swatch.classList.add("is-active");

        const selectedColor = swatch.dataset.color;
        const variantId = swatch.dataset.variantId;

        log("SWATCH CLICK", {
            handle: productItem.dataset.handle,
            selectedColor,
            variantId
        });

        // Update card URL
        if (variantId) {
            const base =
              productItem.dataset.productUrlBase ||
              `${getShopifyRoot()}products/${productItem.dataset.handle}`;
            productItem.dataset.url = `${base}?variant=${variantId}`;
        }

        renderSizes(productItem, selectedColor);
        await updateImages(productItem, selectedColor, variantId);
    }

    

   
